import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  reportLink: '',
  soi: false,
  generalLedger: false,
  balanceSheet: false,
  drd: {},
  drdLink: '',
  drdExportLink: '',
  coownerSectionLink: '',
  loading: false,
  exportLoading: false,
  error: false,
  success: false,
  downloadIncStmtLink: '',
  downloadGLLink: '',
  downloadBalanceSheetLink: '',
  adjustments: {},
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Reports/index.js